/* eslint-disable @typescript-eslint/no-unused-vars */
import { useQuery, useMutation } from "@tanstack/react-query";
import { fetch3, fetch4, fetch5 } from "../commonApis/commonApis";
import { useDispatch } from "react-redux";
const url = process.env.REACT_APP_BASE_URL;

interface ApiResponse {
  success: boolean;
  data: any;
  message?: string;
}

export const usePickupLocationCreateMutation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      console.log("payload >>>>>>>>>>>>", payload);

      const res: ApiResponse = await fetch4(
        `${url}/api/client/pickup-location/outlet?type=outlet`,
        payload,
      );

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Pickup location Created successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Pickup location create request failed:", error.message);
    },
  });
};

export const useUpdateLocationMutation = () => {
  return useMutation({
    mutationFn: async ({
      id,
      ...payload
    }: {
      id: string;
      [key: string]: any;
    }) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/client/pickup-location/outlet/${id}?type=outlet`,
        "PATCH",
        payload,
      );

      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Location updated successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Location update failed:", error.message);
    },
  });
};

export const useFetchPickupLocationData = () => {
  return useQuery({
    queryKey: ["pickupLocationData"],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/client/pickup-location/outlet?type=outlet`,
        "get",
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

// Fetch Outlet Warehouses

export const useFetchOutletWarehouses = () => {
  return useQuery({
    queryKey: ["outletWarehouses"],
    queryFn: async () => {
      const res = await fetch3(`${url}/api/warehouse/all?type=outlet`, "get");

      if (!res || !res.data) {
        return res.message;
      }

      return res.data;
    },
  });
};

export const useFetchAllPickupLocationData = () => {
  return useQuery({
    queryKey: ["allPickupLocationData"],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/client/pickup-location/outlet/all?type=outlet`,
        "get",
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data ?? []; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};
interface UpdateTimeSlotPayload {
  id: string;
  type: string;
  slotName: string;
  days: any;
  startTime: Date;
  endTime: Date;
}
export const useUpdateTimeSlot = () => {
  return useMutation({
    mutationFn: async ({
      id,
      type,
      slotName,
      days,
      startTime,
      endTime,
    }: UpdateTimeSlotPayload) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/time-slot/${id}?type=lmClient`,
        "PUT",
        {
          type,
          slotName,
          days,
          startTime,
          endTime,
        },
      );

      if (!res.success) {
        throw new Error(res.message || "Failed to update vehicle status");
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ time-slot update successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ time-slot update request failed:", error.message);
    },
  });
};

interface UpdatePickupLocationStatusPayload {
  id: string;
  status: any; // Add more statuses if needed
}
export const useUpdatePickupLocationStatus = () => {
  return useMutation({
    mutationFn: async ({ id, status }: UpdatePickupLocationStatusPayload) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/client/pickup-location/outlet/${id}?type=outlet`,
        "PATCH",
        {
          status,
        },
      );

      if (!res.success) {
        throw new Error(
          res.message || "Failed to update Pickup Location status",
        );
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Pick Location status updated successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Pic location status update failed:", error.message);
    },
  });
};

export const usePickupRequestCreateMutation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      console.log("payload >>>>>>>>>>>>", payload);

      const res: ApiResponse = await fetch4(
        `${url}/api/client/pickup-request/outlet?type=outlet`,
        payload,
      );

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Pickup request Created successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Pickup request create request failed:", error.message);
    },
  });
};

export const useFetchOrderShipmentsData = (
  page: number,
  limit: number,
  searchFor: string,
) => {
  return useQuery({
    queryKey: ["orderShipmentsData", page, limit, searchFor],
    queryFn: async () => {
      const res = await fetch3(
        // `${url}/api/orders?filter=[{status: "NEW_ORDER"}]&page=${page}&limit=${limit}&searchFor=${searchFor}&type=outlet`,
        `${url}/api/outlet/order?type=outlet&status=NEW_ORDER`,
        "get",
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data ?? []; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchPickupHistoryData = (
  page: number,
  limit: number,
  searchFor: string,
) => {
  return useQuery({
    queryKey: ["pickupHistoryData", page, limit, searchFor],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/client/pickup-request/outlet?page=${page}&limit=${limit}&searchFor=${searchFor}&type=outlet`,
        "get",
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data ?? []; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchShipmentsViewData = (
  id: any,
  page: number,
  limit: number,
  searchFor: string,
) => {
  return useQuery({
    queryKey: ["shipmentsViewData", page, limit, searchFor],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/client/pickup-request/outlet/${id}?page=${page}&limit=${limit}&searchFor=${searchFor}&type=outlet`,
        "get",
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data ?? []; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useLinehualManifestGenerateMutation = () => {
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: async (payload: {
      fromWarehouseId: string;
      toWarehouseId: string;
      linehaul_load_list: {
        type: string;
        awbs: string[];
      }[];
    }) => {
      const res: ApiResponse = await fetch4(
        `${url}/api/linehaul-manifest/`,
        payload,
      );

      if (!res.success) {
        throw new Error(res.message || "Failed to create linehaul manifest");
      }

      return res.data;
    },

    onSuccess: (data: any) => {
      console.log("✅ Linehaul Manifest Created:", data);

      // dispatch(addLinehaul(data));
    },

    onError: (error: any) => {
      console.error("❌ Linehaul creation failed:", error.message);
    },
  });
};
